<template>
    <div>
        <div class="input-group one gcrg20" v-for="(value, index) in recipients" :key="index">
            <h4 class="bold pc1">Recipient {{ index + 1 }}</h4>
            <div class="form-group grg10">
                <input class="form-control" v-model="value.name"  :id="index + 'first_name'" placeholder="Name" required>
            </div>
            <div class="form-group grg10">
                <input class="form-control" v-model="value.email"  :id="index + 'email'" placeholder="Email" required>
            </div>
            <div class="form-group grg10">
              <textarea class="form-control" v-model="value.message"  :id="index + 'message'" placeholder="Message" required></textarea>
            </div>
            <div class="button" v-if="index === recipients.length - 1">
                <button class="primary rounded jstart" v-on:click="validateAndAdd($event, index)">Add Another Recipient</button>
            </div>
            <div class="button" v-if="index !== 0">
                <button class="primary rounded jstart" v-on:click="deleteRecipient($event, index)">Delete This Recipient</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Recipients",
        data: () => ({
            recipientDetails: {
                name: '',
                email: '',
            },
            recipients: [],
        }),
        methods: {
            addRecipient(details) {
                this.recipients.push(details);
            },
            validateAndAdd(event, index){
                event.preventDefault();
                this.addAnother();
            },
            addAnother() {
                this.recipients.push({name: '', email: ''});
            },
            deleteRecipient(event, key) {
                event.preventDefault();
                console.log(key);
                this.recipients.splice(key,key)
            }
        },
        mounted(){
          this.addRecipient({name:'', email: ''});
        },
        updated() {
            this.$emit('updateRecipients', this.recipients)
        },
    }
</script>

<style scoped>

</style>